import { getLocalToday } from "utils/Common/Date";
import { createElement, useState } from "react";
import { type ReactElement } from "react";
import { pdf, type DocumentProps } from "@react-pdf/renderer";
import {
  getProjectAiaSummary,
  getProjectAiaBillingSummary,
} from "services/projectService";
import AiaPdf, { AiaPdfProps } from "Components/Common/AiaPdf/AiaPdf";

export const useAiaPdf = () => {
  const [isExportingPdf, setIsExportingPdf] = useState(false);

  const exportAiaPdf = async (
    projectId: string,
    projectName?: string,
    lenderName?: string,
    role: "admin" | "lender" | "owner" | "gc" = "lender",
    showG702 = true,
  ) => {
    if (!projectId) return;
    setIsExportingPdf(true);
    try {
      const isGc = role === "gc";
      const { data } = isGc
        ? await getProjectAiaBillingSummary(projectId, role)
        : await getProjectAiaSummary(projectId, role);
      const summary = data?.data;
      if (!summary) throw new Error("No AIA data available");

      const props: AiaPdfProps = {
        g702: summary.g702,
        g703Rows: summary.g703?.lineItems ?? [],
        retainageRate:
          summary.g703?.retainageRate || summary.g702?.retainageRate || "",
        projectName,
        lenderName,
        showG702,
        variant: isGc ? "gc" : "standard",
      };

      const el = createElement(AiaPdf, props) as ReactElement<DocumentProps>;
      const blob = await pdf(el).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${showG702 ? "AIA-G702-G703" : "AIA-G703"}-${projectName ?? "export"}-${getLocalToday()}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } finally {
      setIsExportingPdf(false);
    }
  };

  return { exportAiaPdf, isExportingPdf };
};
